import React from 'react';
import { useLang } from '../context/LanguageContext';
import { CheckCircle2, X, Loader2 } from 'lucide-react';

const FormShell = ({ title, desc, children, onSubmit, submitting, locked, success, onReset, close, refNo, successTitle, successBody, successCta, successCtaLabel }) => {
  const { t } = useLang();
  const disabled = submitting || locked;
  return (
    <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[92vh] overflow-y-auto">
      <div className="flex items-start justify-between p-6 border-b border-[#E8E1CE]">
        <div>
          <h3 className="text-2xl font-bold text-[#0B5D3B]">{title}</h3>
          {desc && <p className="text-sm text-[#33473d]/80 mt-1">{desc}</p>}
        </div>
        {close && <button type="button" onClick={close} className="p-1 text-[#33473d] hover:text-[#0B5D3B]"><X size={22} /></button>}
      </div>
      <div className="p-6">
        {success ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 rounded-full bg-[#0B5D3B]/10 mx-auto flex items-center justify-center mb-4">
              <CheckCircle2 className="w-9 h-9 text-[#0B5D3B]" />
            </div>
            <h4 className="text-xl font-bold text-[#0B5D3B] mb-2">{successTitle || t.common.thankYou}</h4>
            <p className="text-[#33473d]">{successBody || t.common.requestReceived}</p>
            {refNo && (
              <p className="mt-3 text-sm text-[#33473d]/70">
                {t.common.referenceNo}:{' '}
                <span className="font-mono font-semibold text-[#0B5D3B]" dir="ltr">{refNo}</span>
              </p>
            )}
            <div className="mt-6 flex flex-wrap gap-3 justify-center">
              {successCta && <button type="button" onClick={successCta} className="btn-green">{successCtaLabel}</button>}
              <button type="button" onClick={onReset} className={successCta ? 'btn-green-outline' : 'btn-green'}>{t.common.submitAnother}</button>
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            {children}
            <button type="submit" disabled={disabled} className="btn-gold w-full justify-center mt-2 disabled:opacity-60 disabled:cursor-not-allowed">
              {submitting ? <><Loader2 className="w-4 h-4 animate-spin" />{t.common.submitting}</> : t.common.submit}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export const Field = ({ label, required, children }) => (
  <div>
    <label className="block text-sm font-medium text-[#33473d] mb-1.5">{label}{required && <span className="text-red-500 ms-1">*</span>}</label>
    {children}
  </div>
);

export const inputCls = 'w-full border border-[#E8E1CE] rounded-md px-3.5 py-2.5 text-sm bg-white text-[#1F2937] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#0B5D3B]/30 focus:border-[#0B5D3B] transition';
export default FormShell;
